import { render, staticRenderFns } from "./NewHighScorePrompt.vue?vue&type=template&id=f78410e0"
import script from "./NewHighScorePrompt.vue?vue&type=script&lang=js"
export * from "./NewHighScorePrompt.vue?vue&type=script&lang=js"
import style0 from "./NewHighScorePrompt.vue?vue&type=style&index=0&id=f78410e0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports